import React from 'react';

import { DesignTokenColor } from '@src/theme';
import { extractLayoutProps, extractSpacingProps } from '@src/theme/common';
import { getTestId } from '@src/utils/testIds';
import { InternalBox } from '../Box/InternalBox';
import { Box } from '../Box';
import { SHADOW_MAP } from './const';
import type { InternalCardProps } from './interface';

export function InternalCard(props: InternalCardProps) {
  const { bgColor = 'surface.paper', children, elevation = 0, onClick } = props;
  const spacingProps = extractSpacingProps(props);
  const layoutProps = extractLayoutProps(props);

  // Default to 100% width if one is not provided
  layoutProps.width = layoutProps.width ?? '100%';

  // The only card with a border defaulted is a zero elevation card
  const [borderColor, borderWidth, borderStyle]: [DesignTokenColor?, number?, 'solid'?] = (() => {
    if (props.borderColor) {
      return [props.borderColor, 1, 'solid'];
    }

    if (elevation === 0) {
      return ['controls.backing+line', 1, 'solid'];
    }

    return [undefined, undefined, undefined];
  })();

  const shadow = elevation ? SHADOW_MAP[elevation] : undefined;

  return (
    <Box {...spacingProps} {...layoutProps}>
      <InternalBox
        bgColor={bgColor}
        borderColor={borderColor}
        borderWidth={borderWidth}
        borderStyle={borderStyle}
        borderRadius="12px"
        p={2}
        width="100%"
        height="100%"
        shadow={shadow}
        onClick={onClick}
        testId={getTestId(props)}
      >
        {children}
      </InternalBox>
    </Box>
  );
}
